import { render, staticRenderFns } from "./ParamsSelector.vue?vue&type=template&id=18389cac&scoped=true&"
import script from "./ParamsSelector.vue?vue&type=script&lang=ts&"
export * from "./ParamsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ParamsSelector.vue?vue&type=style&index=0&id=18389cac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18389cac",
  null
  
)

export default component.exports